export default "__VITE_ASSET__Bkm9lqnA__"